import { DateConverter } from "./date-converter";
import { BufferConverter } from "./buffer-converter";
export var propertyConverters = new Map();
// Only import Buffer code if running in NodeJS
if (typeof window === "undefined") {
    propertyConverters.set(Buffer, new BufferConverter());
}
propertyConverters.set(Date, new DateConverter());
